import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { AbvPipeDayForm } from './AbvPipeDayForm';

export const AbvPipeDayDetail = () => {
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <AbvPipeDayForm /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}